import { useEffect, useRef } from 'react';
import { useGetAllTypesQuery } from '../api/api-hooks';

export const useHardwareTypeMap = () => {
  const { data: hardwareTypes } = useGetAllTypesQuery({});
  const typeMap = useRef<Map<number, string>>();
  useEffect(() => {
    typeMap.current = new Map<number, string>();
    if (hardwareTypes === undefined) return;
    for (const type of hardwareTypes) {
      typeMap.current.set(type.id, type.typeName);
    }
  }, [hardwareTypes]);
  if (hardwareTypes === undefined) return;
  if (!typeMap.current) {
    typeMap.current = new Map<number, string>();
    for (const type of hardwareTypes) {
      typeMap.current?.set(type.id, type.typeName);
    }
  }
  if (typeMap.current.size === 0) {
    for (const type of hardwareTypes) {
      typeMap.current?.set(type.id, type.typeName);
    }
  }
  return typeMap.current;
};
